import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {ButtonType} from "../../../modules/shared/components/button/button.component";

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  currentConfigSubject: Subject<{
    open?: boolean;
    title?: string;
    modalFace?: string;
    message?: string;
    positiveButtonText?: string;
    positiveButtonClick?: () => void;
    negativeButtonText?: string;
    negativeButtonClick?: () => void;
    isCancelable?: boolean;
    showCloseButton?: boolean;
    positiveButtonType?: ButtonType;
    negativeButtonType?: ButtonType;
  }> = new Subject();

  /**
   * Displays a modal dialog with customizable options.
   *
   * @param title Modal title.
   * @param message Message to display.
   * @param positiveButtonText Text for positive button.
   * @param positiveButtonClick Callback for positive button.
   * @param negativeButtonText Text for negative button.
   * @param negativeButtonClick Callback for negative button.
   * @param isCancelable Indicates if modal can be closed without button press.
   */
  showModal(
    title?: string,
    modalFace?: string,
    message?: string,
    positiveButtonText?: string,
    positiveButtonClick?: () => void,
    negativeButtonText?: string,
    negativeButtonClick?: () => void,
    positiveButtonType?: ButtonType,
    negativeButtonType?: ButtonType,
    isCancelable?: boolean,
    showCloseButton?: boolean
  ): void {
    this.currentConfigSubject.next({
      open: true,
      title: title ?? 'error',
      modalFace: modalFace ?? 'sad',
      message: message ?? 'somethingWentWrong',
      positiveButtonText: positiveButtonText ?? 'yes',
      positiveButtonClick: positiveButtonClick,
      negativeButtonText: negativeButtonText,
      negativeButtonClick: negativeButtonClick,
      isCancelable: isCancelable ?? true,
      positiveButtonType: positiveButtonType ?? 'primary',
      negativeButtonType: negativeButtonType ?? 'secondary',
      showCloseButton: showCloseButton ?? true,
    });
  }

  /**
   * Dismiss the message modal.
   */
  dismissModal(): void {
    this.currentConfigSubject.next({
      open: false,
    });
  }
}
